"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const react_1 = __importDefault(require("react"));
const Spinner_styles_1 = require("./Spinner.styles");
/**
 * @deprecated please use <Ds.Spinner/> instead
 */
const Spinner = ({ hiddenLabel = "Loading...", colour = "blue", dimension = "medium", placement = "center", className, }) => {
    return (react_1.default.createElement(Spinner_styles_1.StyledWrapper, { placement: placement, className: className, "aria-live": "assertive" },
        react_1.default.createElement(Spinner_styles_1.StyledSpinner, { colour: colour, dimension: dimension, role: "status" },
            react_1.default.createElement(Spinner_styles_1.StyledSpinnerHiddenText, null, hiddenLabel))));
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map